"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, switchMap, catchError, map } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvOrdersConstants } from "../_constants/lcvOrders.constants";
import {
     lcvOrdersPreviewImportComplete,
     lcvOrdersImportComplete,
     lcvOrdersGetImportHistoryComplete,
} from "../_actions/lcvOrders.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";

// The workbook itself is sent, so these two go up as multipart. The content type is left to the
// browser: setting it by hand loses the boundary and the file never arrives.
const postFile = (url, complete) =>
     mergeMap((incoming) => {
          const formData = new FormData();

          formData.append("orderFile", incoming.payload.file);

          return ajax
               .post(url, formData, getRequestHeader(requestTypes.REQUEST_TYPE_FILE_UPLOAD))
               .pipe(
                    map((ajaxResponse) => complete(ajaxResponse.response)),
                    catchError((error) => of(ajaxError(error))),
               );
     });

export const lcvOrdersPreviewImportEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvOrdersConstants.LCV_ORDERS_PREVIEW_IMPORT_REQUEST),
          postFile("/api/lcvOrders/previewImport", lcvOrdersPreviewImportComplete),
     );
};

export const lcvOrdersImportEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvOrdersConstants.LCV_ORDERS_IMPORT_REQUEST),
          postFile("/api/lcvOrders/importOrders", lcvOrdersImportComplete),
     );
};

export const lcvOrdersGetImportHistoryEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvOrdersConstants.LCV_ORDERS_GET_IMPORT_HISTORY_REQUEST),
          switchMap((incoming) =>
               ajax
                    .post(
                         "/api/lcvOrders/getImportHistory",
                         incoming.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              lcvOrdersGetImportHistoryComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    ),
          ),
     );
};
